import {
    Component,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    SimpleChanges
} from '@angular/core';
import {
    Lotam,
    MissionCrewDto,
    NoticeDto,
    Organisation,
    UserService
} from '@flyfreely-portal-ui/flyfreely';
import { MODAL_OPTIONS } from '@flyfreely-portal-ui/ngx-bootstrap-customisation';
import { collapseAnimation } from 'angular-animations';
import { MissionNoticeAcknowledgementDto } from 'libs/flyfreely/src/lib/model/api/missionNoticeAcknowledgementDto';
import { MissionNoticesDataService } from 'libs/notices/src/lib/mission-notices-data.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LocationBearing } from '../../bearing.pipe';
import { MissionLotamDetailsComponent } from '../mission-lotam-details/mission-lotam-details.component';

@Component({
    selector: 'mission-lotam-summary',
    templateUrl: './mission-lotam-summary.component.html',
    styleUrls: ['./mission-lotam-summary.component.scss'],
    animations: [collapseAnimation()]
})
export class MissionLotamSummaryComponent
    implements OnInit, OnDestroy, OnChanges
{
    @Input() lotam: NoticeDto;
    @Input() acknowledgementList: Array<MissionNoticeAcknowledgementDto>;
    @Input() isExpanded = false;
    @Input() missionId: number;
    @Input() organisation: Organisation;
    @Input() missionCrew: MissionCrewDto[];
    @Input() locationBearing: LocationBearing;
    @Input() isReadOnly = false;
    private ngUnsubscribe$ = new Subject<void>();

    isAcknowledged = false;
    acknowledgementTime?: string;
    isInMissionCrew = false;

    constructor(
        private userService: UserService,
        private modalService: BsModalService
    ) {}

    ngOnInit(): void {
        this.refreshAcknowledged();
        this.refreshMissionCrew();
    }

    ngOnChanges(changes: SimpleChanges) {
        if ('missionCrew' in changes) {
            this.refreshMissionCrew();
        }
    }

    ngOnDestroy() {
        this.ngUnsubscribe$.next();
        this.ngUnsubscribe$.complete();
    }

    get buttonText(): string {
        if (this.isReadOnly) {
            return 'View';
        }
        return this.isAcknowledged ? 'View' : 'Acknowledge';
    }

    refreshAcknowledged() {
        const currentUserId = this.userService.getCurrentUser().id;
        const maybeAcknowledgement = this.acknowledgementList.find(
            item => item.personId === currentUserId
        );
        this.acknowledgementTime = maybeAcknowledgement?.acknowledgementTime;
        this.isAcknowledged = maybeAcknowledgement != null;
    }

    viewLotamDetail() {
        const dialogue = this.modalService.show<MissionLotamDetailsComponent>(
            MissionLotamDetailsComponent,
            {
                ...MODAL_OPTIONS,
                class: 'modal-lg',
                initialState: {
                    lotam: {
                        ...this.lotam,
                        isAcknowledged: this.isAcknowledged,
                        currentUserAcknowledgementTime: this.acknowledgementTime
                    } as Lotam,
                    missionId: this.missionId,
                    organisation: this.organisation,
                    isAcknowledgedInMission: this.isAcknowledged,
                    isReadOnly: this.isReadOnly
                },
                providers: [
                    {
                        provide: MissionNoticesDataService
                    }
                ]
            }
        );
        dialogue.content.acknowledge
            .pipe(takeUntil(this.ngUnsubscribe$), takeUntil(dialogue.onHide))
            .subscribe(acknowledgedPerson => {
                this.acknowledgementList.push(acknowledgedPerson);
                this.refreshAcknowledged();
            });
    }

    refreshMissionCrew() {
        const currentUserId = this.userService.getCurrentUser().id;
        this.isInMissionCrew = this.missionCrew.some(
            m => m.personId === currentUserId
        );
    }
}
